<div class="summary">
    <div class="text">
        {{petition.text}}
    </div>
    <div class="dateRange">
        {{petition | dateRange}}
    </div>
</div>